// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-header__title p{font-size:18px;font-size:1.125rem;line-height:1.5rem;margin:0}.section-header__title small{display:inline-block;font-size:18px;font-size:1.125rem;line-height:1.5rem}.section-header__link{text-align:right}.section-header__link a:before{font-size:12px;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
